/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {useGetCallibrationDataWithFilters} from '@agent-assist/api-typescript-react-query-hooks';
import type {GridFilterModel} from '@mui/x-data-grid-premium';
import type {DateRangeValue} from '../../components/SuperTable/SuperDatePicker';
import {toColumns, toRows} from '../../services/super-table-service';
import {convertFilters} from '../../services/super-table-utils';

interface GetContactsFilteredParams {
  contactImportId: string;
  filterModel?: GridFilterModel;
  dateRange?: DateRangeValue;
  pageSize: number;
}

export const useGetContactsFiltered = () => {
  const {mutateAsync, isError, isLoading, isSuccess} = useGetCallibrationDataWithFilters();

  const get = async ({contactImportId, filterModel, dateRange, pageSize}: GetContactsFilteredParams) => {
    const filters = filterModel ? convertFilters(filterModel) : [];
    const [from, to] = dateRange || [];
    try {
      const {analytics} = await mutateAsync({
        contactImportId,
        pageSize,
        getCallibrationDataWithFiltersRequestContent: {
          filters,
          from: from?.toISOString() ?? undefined,
          to: to?.toISOString() ?? undefined,
        },
      });
      const rows = toRows(analytics, {idField: 'contactId'});
      const columns = toColumns(analytics);
      return {rows, columns};
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return {get, isError, isLoading, isSuccess};
};
